module.exports = __webpack_public_path__ + "img/globe.8d835da4.svg";